export default __webpack_public_path__ + "static/media/card-back-square.1515edf7.jpg";